import { render, staticRenderFns } from "./HeaderAds.vue?vue&type=template&id=cdd93aa4&scoped=true"
import script from "./HeaderAds.vue?vue&type=script&lang=js"
export * from "./HeaderAds.vue?vue&type=script&lang=js"
import style0 from "./HeaderAds.vue?vue&type=style&index=0&id=cdd93aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd93aa4",
  null
  
)

export default component.exports